import * as React from "react"
import Radio from "@mui/material/Radio"
import RadioGroup from "@mui/material/RadioGroup"
import FormControlLabel from "@mui/material/FormControlLabel"
import FormControl from "@mui/material/FormControl"
import FormLabel from "@mui/material/FormLabel"
import theme from "src/v2/theme/theme"
import { Typography } from "@mui/material"
import PropTypes from "prop-types"

const GenericRadioButton = ({
    title,
    radioButtonItems,
    defaultRadioValue,
    onChange,
}) => {
    return (
        <FormControl
            sx={{
                display: "flex",
                width: "100%",
            }}
        >
            <FormLabel id="access-level-radio-buttons-group-label">
                <Typography
                    variant="contraHeading"
                    sx={{ color: theme.palette.primary.white70 }}
                >
                    {title}
                </Typography>
            </FormLabel>
            <RadioGroup
                aria-labelledby="access-level-radio-buttons-group-label"
                defaultValue={defaultRadioValue}
                name="radio-buttons-group"
                onChange={onChange}
            >
                {radioButtonItems.map((option) => (
                    <FormControlLabel
                        key={option.value}
                        value={option.value}
                        control={
                            <Radio
                                sx={{
                                    "&.Mui-checked": {
                                        color: theme.palette.primary.main2,
                                        "& .MuiSvgIcon-root:last-of-type": {
                                            transform: "scale(0.5)",
                                        },
                                    },
                                    "& .MuiSvgIcon-root": {
                                        width: "20px",
                                        height: "20px",
                                    },
                                    "& .MuiSvgIcon-root:first-of-type": {
                                        color: theme.palette.white.main,
                                    },
                                }}
                            />
                        }
                        label={
                            <Typography variant="body2" color="common.white">
                                {option.label}
                            </Typography>
                        }
                        sx={{
                            height: "24px",
                        }}
                    />
                ))}
            </RadioGroup>
        </FormControl>
    )
}

GenericRadioButton.propTypes = {
    title: PropTypes.string.isRequired,
    defaultRadioValue: PropTypes.string.isRequired,
    radioButtonItems: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
        })
    ).isRequired,
    onChange: PropTypes.func,
}

export default GenericRadioButton
